import React from 'react';
import Hero from './Hero';
import StickyHeader from './StickyHeader';
import PromotionalBanner from './PromotionalBanner';
import AddressHoursSection from './AddressHoursSection';
import DetailsSection from './DetailsSection';
import Breadcrumbs from '../../Breadcrumbs';
import AppPromoBanner from '../../branding/AppPromoBanner';
import styles from './LDP.module.css';

/**
 * @param {object} props
 * @param {FF.Location__LDP} props.locationData
 */
export default function LDP({ locationData }) {
  return (
    <div className={styles.wrapper}>
      <Breadcrumbs
        className={styles.breadcrumbs}
        links={[
          { label: 'Home', url: '/' },
          { label: 'Locations', url: '/locations-map' },
          { label: 'Details', url: locationData.LDPPagePath },
        ]}
      />
      <Hero locationData={locationData} />
      <StickyHeader locationData={locationData} />
      <PromotionalBanner locationData={locationData} />
      <AppPromoBanner className={styles.appPromoBanner} />
      <AddressHoursSection locationData={locationData} />
      {locationData.type === 'FRIDGE' && (
        <>
          <hr className={styles.divider} />
          <DetailsSection locationData={locationData} />
        </>
      )}
    </div>
  );
}
